import classNames from 'classnames'
import { type ReactNode } from 'react'
import styles from './Alert.module.css'

interface AlertProps {
  variant?: 'warning' | 'info'
  children: ReactNode
}

export function Alert({ variant = 'warning', children }: AlertProps) {
  return (
    <div className={classNames(styles['alert'], styles[variant])}>{children}</div>
  )
}
